import { render, staticRenderFns } from "./reservationRefund.vue?vue&type=template&id=5c5ff29a&scoped=true&"
import script from "./reservationRefund.vue?vue&type=script&lang=ts&"
export * from "./reservationRefund.vue?vue&type=script&lang=ts&"
import style1 from "./reservationRefund.vue?vue&type=style&index=1&id=5c5ff29a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5ff29a",
  null
  
)

export default component.exports